import { IConfigurationAction } from './config.actions';
import { IConfig } from '../../services/configuration.service';

export function configReducer(state: IConfig, action: IConfigurationAction) {
  switch (action.type) {

    default:
      return state;

  }
}
